/** Read the same T5 amounts in signing and read-only views without changing the XML. */
export const getWaybillTitlePrices = (xml: string) => ({
    price: xml.match(/СтТовБезНДС="([\d.]+)"/)?.[1],
    taxRate: xml.match(/НалСт="([\d%]+|без НДС)"/)?.[1],
    priceWithTaxRate: xml.match(/СтТовУчНал="([\d.]+)"/)?.[1],
    taxPrice: xml.match(/НДС>([\d.]+|без НДС)<\/(Сум|Без)НДС>/)?.[1],
});
